module.exports = "define('com/fitbit/app/modules/message.fr_FR', {\"namespace\":\"com.fitbit.app.modules.message\",\"translations\":{\"chars_remaining_primary_singular\":\"{0} caractère restant\",\"chars_remaining_primary_plural\":\"{0} caractères restants\"}});"


/*****************
 ** WEBPACK FOOTER
 ** /home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts/catpack/web_loaders/script-loader/~/raw-loader!../build/assets/i18n/app/modules/message.fr_FR.js
 ** module id = 18
 ** module chunks = 1 2 4 5
 **/